import React from 'react';
import {
    Button, Form, FormGroup, Label,
    Col,
    Container, Row
} from 'reactstrap';

import SelectListComponent from '../utils/selectList';
import DateSelector from '../utils/dateSelector';

const SearchPanel = ({contentErrorText,categories, selectedCat, multiOptions, multiLabelKey, multiValueKey, multiArray, onCatValueChange, onMultiValueChange, onSearch, startDateChange, endDateChange }) => {
    return (
        <Form onSubmit={e => e.preventDefault()}>
            <Container>
                <Row>
                    <Col xs="6" sm="2">
                        <FormGroup className="mb-2">
                            <Label>Start Date</Label>
                            <DateSelector
                            maxDate={new Date()}
                            todayDate={(new Date()).toString()}
                            name="startDate" onValueChange={startDateChange} />
                        </FormGroup>
                    </Col>
                    <Col xs="6" sm="2">
                        <FormGroup className="mb-2">
                            <Label>End Date</Label>
                            <DateSelector
                            maxDate={new Date()}
                            todayDate={(new Date()).toString()}
                            name="endDate" onValueChange={endDateChange} />
                        </FormGroup>
                    </Col>
                    <Col xs="6" sm="2">
                        <FormGroup className="mb-2">
                            <Label>Categories</Label>
                            <SelectListComponent data={categories} valueKey='value' textField='label' selectValue={selectedCat} onValueChange={onCatValueChange} />
                        </FormGroup>
                    </Col>
                    <Col xs="6" sm="5">
                        <FormGroup className="mb-2">
                            <Label>Search Box</Label>
                            <SelectListComponent data={multiOptions} multiSelectMode={true} selectValue={multiArray} valueKey={multiValueKey} textField={multiLabelKey} onValueChange={onMultiValueChange} />
                        <span style={{color:'red'}}>{contentErrorText}</span>
                        </FormGroup>
                    </Col>
                    <Col xs="6" sm="1">
                        <label>&nbsp;</label>
                        <Button className="btn-avi-primary" onClick={() => onSearch(1)}>Search</Button>
                    </Col>
                </Row>
            </Container>

        </Form>
    )
};


export default SearchPanel;



// WEBPACK FOOTER //
// ./src/views/unbillled-passengers/unbilled-panel.js